import { UserThemeStatusEnum } from '../../../../core/enum/user_theme_status_enum';
import { UserThemeInterface } from '../interface/user_theme_interface';

const themeIdOf = (userTheme: UserThemeInterface): string | undefined =>
  typeof userTheme._themeId === 'string' ? userTheme._themeId : userTheme._themeId?._id;

export const getCompanyUserThemes = (
  course_theme: UserThemeInterface[] | undefined,
  companyId: string | undefined,
): UserThemeInterface[] => {
  if (!companyId) return [];
  return course_theme?.filter(theme => theme._companyId === companyId) ?? [];
};

export const getUserThemeByThemeId = (
  course_theme: UserThemeInterface[] | undefined,
  themeId: string | undefined,
  companyId: string | undefined,
): UserThemeInterface | undefined => {
  if (!themeId) return undefined;
  return getCompanyUserThemes(course_theme, companyId).find(theme => themeIdOf(theme) === themeId);
};

export const getCurrentUserTheme = (
  course_theme: UserThemeInterface[] | undefined,
  companyId: string | undefined,
): UserThemeInterface | undefined =>
  getCompanyUserThemes(course_theme, companyId).find(
    theme => theme.status === UserThemeStatusEnum.InProgress && theme._themeId,
  );
